module.exports = __webpack_public_path__ + "common/gh-arrow-down-icon-e6b824def086f28ae18eddfbe1687134.svg";